import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [logoError, setLogoError] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About us', href: '#about' },
    { name: 'Our Expertise', href: '#expertise' },
    { name: 'Our Founder', href: '#founder' },
    // { name: 'Media', href: '#media' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        scrolled ? 'bg-primary bg-opacity-90 backdrop-blur-md h-16 shadow-lg' : 'bg-primary/30 backdrop-blur-sm h-20'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center h-full">
        <a href="#" className="flex items-center">
          {logoError ? (
            <h1 className="font-['Bodoni_Moda'] text-2xl md:text-3xl font-bold text-neutral tracking-wider">
              <span className="text-[1.3em]">Q</span>UANTUM<span className="text-[1.3em]">S</span>PHERE
            </h1>
          ) : (
            <img 
              src="/logo.svg" 
              alt="QuantumSphere Logo" 
              className="h-8 md:h-10" 
              onError={() => setLogoError(true)}
            />
          )}
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-neutral hover:text-accent transition-colors duration-300 font-medium" 
              onClick={(e) => {
                if (link.href === '#contact') {
                  e.preventDefault();
                  document.getElementById('contact-heading')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
            >
              {link.name}
            </a>
          ))}
          <a 
            href="#contact" 
            className="bg-accent text-white hover:bg-transparent hover:text-accent border-2 border-accent px-4 py-2 rounded-md transition-all duration-300"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact-heading')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }}
          >
            Get in Touch
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-neutral focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-primary bg-opacity-95 backdrop-blur-md"
          >
            <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-neutral hover:text-accent transition-colors duration-300 py-2 font-medium"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a 
                href="#contact" 
                className="bg-accent text-white hover:bg-transparent hover:text-accent border-2 border-accent px-4 py-2 rounded-md transition-all duration-300 inline-block text-center"
                onClick={() => setIsOpen(false)}
              >
                Get in Touch
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;